import CustomError from './CustomError'

export default class ExpiredOtpException extends CustomError {
  constructor(message: string) {
    super(message)
  }
}
